export class ContentAccountRecovery {
  id?: string;
  label?: string;
  accountRecoveryLink?: string;
  accountRecoveryToolTipHeader?: string;
  accountRecoveryToolTipLabel?: string;
  hideAccountRecoveryTooltip?: string;
  accountRecoveryNavLink?: string;
  mfaToolTipDisplayPages?: string[];

  constructor(contentJson?: any) {
    this.id = contentJson?.id ?? null;
    this.label = contentJson?.label ?? null;
    this.accountRecoveryLink = contentJson?.accountRecoveryLink ?? null;
    this.accountRecoveryToolTipLabel =
      contentJson?.accountRecoveryToolTipLabel ?? null;
    this.accountRecoveryToolTipHeader =
      contentJson?.accountRecoveryToolTipHeader ?? null;
    this.hideAccountRecoveryTooltip =
      contentJson?.hideAccountRecoveryTooltip ?? null;
    this.accountRecoveryNavLink = contentJson?.accountRecoveryNavLink ?? null;
    this.mfaToolTipDisplayPages = contentJson?.mfaToolTipDisplayPages ?? null;
  }
}
